export default {
  street: 'info.address.street',
  city: 'info.address.city',
  state: 'info.address.state',
  zip: 'info.address.zip',
};
